export const STORE_FILTER_DATA_KEY = 'store:filterData';

export const clearStoreFilterData = () => {
  localStorage.removeItem(STORE_FILTER_DATA_KEY);
};

export const getStoreFilterData = () => {
  return JSON.parse(localStorage.getItem(STORE_FILTER_DATA_KEY) || '{}');
};

export const setStoreFilterData = (data: Record<string, any>) => {
  localStorage.setItem(STORE_FILTER_DATA_KEY, JSON.stringify(data));
};
